// Grants — the atomic unit of YES Foundation's funding to implementation partners.
// Each partner may have 1+ grants. A grant has its own status, score, and lifecycle.

import { PARTNERS } from "./partners";

export const GRANTS = [
  // ── Employability grants ──────────────────────────────────────
  { id: "YBF-G-001", name: "Skill-to-Job Cohort '25",         partnerId: "anudip",        beneficiaries: 1200, fundedCr: 1.9, since: 2024, status: "Active", score: 4.6 },
  { id: "YBF-G-002", name: "Digital Literacy Bridge",         partnerId: "anudip",        beneficiaries: 900,  fundedCr: 1.5, since: 2022, status: "Active", score: 4.2 },
  { id: "YBF-G-003", name: "STRIVE Retail Pathway",           partnerId: "tatastrive",    beneficiaries: 1100, fundedCr: 1.9, since: 2023, status: "Active", score: 4.8 },
  { id: "YBF-G-004", name: "STRIVE Auto Service Skilling",    partnerId: "tatastrive",    beneficiaries: 750,  fundedCr: 1.2, since: 2021, status: "Closed", score: 4.0 },
  { id: "YBF-G-005", name: "EduBridge Tech Foundation",       partnerId: "edubridge",     beneficiaries: 900,  fundedCr: 1.7, since: 2023, status: "Active", score: 3.9 },
  { id: "YBF-G-006", name: "EduBridge BFSI Track",            partnerId: "edubridge",     beneficiaries: 520,  fundedCr: 0.9, since: 2022, status: "Active", score: 3.4 },
  { id: "YBF-G-007", name: "FUEL Industry-Ready Programme",   partnerId: "fuel",          beneficiaries: 920,  fundedCr: 1.7, since: 2022, status: "Active", score: 4.1 },
  { id: "YBF-G-008", name: "Centum Skilling Centres",         partnerId: "centum",        beneficiaries: 1100, fundedCr: 2.0, since: 2023, status: "Active", score: 3.7 },
  { id: "YBF-G-009", name: "Yuva Unstoppable Schools",        partnerId: "yuvaunstoppable",beneficiaries: 740, fundedCr: 1.3, since: 2024, status: "Active", score: 2.8 },
  { id: "YBF-G-010", name: "TRRAIN Retail Academy",           partnerId: "trrain",        beneficiaries: 680,  fundedCr: 1.2, since: 2023, status: "Active", score: 4.3 },
  { id: "YBF-G-011", name: "VIDYA Women in Tech",             partnerId: "vidya",         beneficiaries: 540,  fundedCr: 0.9, since: 2024, status: "Active", score: 3.5 },

  // ── Entrepreneurship grants ───────────────────────────────────
  { id: "YBF-G-012", name: "WOTR Watershed-Marathwada",       partnerId: "wotr",          beneficiaries: 2400, fundedCr: 2.6, since: 2023, status: "Active", score: 4.7 },
  { id: "YBF-G-013", name: "WOTR Climate-Resilient Cluster",  partnerId: "wotr",          beneficiaries: 1800, fundedCr: 2.2, since: 2024, status: "Active", score: 4.4 },
  { id: "YBF-G-014", name: "PRADAN SHG Income Lift",          partnerId: "pradan",        beneficiaries: 2200, fundedCr: 2.4, since: 2023, status: "Active", score: 4.5 },
  { id: "YBF-G-015", name: "PRADAN Tasar Silk Livelihood",    partnerId: "pradan",        beneficiaries: 1600, fundedCr: 1.8, since: 2022, status: "Active", score: 4.0 },
  { id: "YBF-G-016", name: "TBS Johad Revival",               partnerId: "tbs",           beneficiaries: 2600, fundedCr: 2.9, since: 2022, status: "Active", score: 4.6 },
  { id: "YBF-G-017", name: "Mahashakti Nano-Enterprise",      partnerId: "mahashakti",    beneficiaries: 2100, fundedCr: 2.3, since: 2023, status: "Active", score: 4.1 },
  { id: "YBF-G-018", name: "Head Held High Rural BPO",        partnerId: "headheldhigh",  beneficiaries: 1800, fundedCr: 1.9, since: 2023, status: "Active", score: 3.8 },
  { id: "YBF-G-019", name: "Humana Handloom Co-op",           partnerId: "humana",        beneficiaries: 1000, fundedCr: 1.1, since: 2022, status: "Active", score: 4.2 },
  { id: "YBF-G-020", name: "Humana Tailoring Cluster",        partnerId: "humana",        beneficiaries: 600,  fundedCr: 0.7, since: 2023, status: "Active", score: 3.6 },
  { id: "YBF-G-021", name: "SIIRD Rural FPO Capacity",        partnerId: "siird",         beneficiaries: 1200, fundedCr: 1.4, since: 2022, status: "Closed", score: 3.2 },
  { id: "YBF-G-022", name: "Ambuja Farmer Producer Org",      partnerId: "ambuja",        beneficiaries: 1000, fundedCr: 1.2, since: 2024, status: "Active", score: 3.9 },

  // ── Environment grants ────────────────────────────────────────
  { id: "YBF-G-023", name: "SankalpTaru Agroforestry-West",   partnerId: "sankalptaru",   beneficiaries: 0,    fundedCr: 2.6, since: 2023, status: "Active", score: 4.5, trees: 140000 },
  { id: "YBF-G-024", name: "SankalpTaru Native Tree Belt",    partnerId: "sankalptaru",   beneficiaries: 0,    fundedCr: 2.6, since: 2024, status: "Active", score: 4.3, trees: 140000 },
  { id: "YBF-G-025", name: "FMC MSME Energy Audit",           partnerId: "fmc",           beneficiaries: 320,  fundedCr: 1.4, since: 2023, status: "Active", score: 4.0, msmes: 320 },
  { id: "YBF-G-026", name: "FMC Cluster Decarbonisation",     partnerId: "fmc",           beneficiaries: 200,  fundedCr: 1.0, since: 2024, status: "Active", score: 3.4, msmes: 200 },
  { id: "YBF-G-027", name: "Raah Forest Restoration",         partnerId: "raah",          beneficiaries: 0,    fundedCr: 1.8, since: 2022, status: "Active", score: 4.6, trees:  95000 },
  { id: "YBF-G-028", name: "Grow Trees Karnataka Drive",      partnerId: "grow",          beneficiaries: 0,    fundedCr: 1.4, since: 2023, status: "Closed", score: 3.1, trees:  75000 },
];

// ── Helpers ──────────────────────────────────────────────────────
const partnerLookup = PARTNERS.reduce((acc, p) => { acc[p.id] = p; return acc; }, {});

// Deterministic 32-bit FNV-1a hash so disbursement / utilisation values are stable
function hash(str) {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return (h >>> 0);
}

export function enrichGrant(g) {
  const p = partnerLookup[g.partnerId];

  // Disbursement: Closed grants run 92–100%, Active 55–95% of sanctioned
  const h1 = hash(g.id + ":disb");
  const h2 = hash(g.id + ":util");
  const isClosed = g.status === "Closed";
  const disbursePct = isClosed ? 92 + (h1 % 9) : 55 + (h1 % 41);   // %
  // Utilisation: % of disbursed actually used on ground
  const utilisePct  = isClosed ? 94 + (h2 % 7)  : 70 + (h2 % 29);  // %

  const disbursedCr = +(g.fundedCr * (disbursePct / 100)).toFixed(2);
  const utilisedCr  = +(disbursedCr * (utilisePct / 100)).toFixed(2);

  return {
    ...g,
    partnerName: p?.name || "—",
    pillar: p?.pillar,
    states: p?.states || [],
    disbursedCr,
    utilisedCr,
    disbursePct,
    utilisePct,
  };
}

export function grantsForPillar(pillarId) {
  return GRANTS.map(enrichGrant).filter((g) => g.pillar === pillarId);
}

// RAG mapping for grant score (out of 5)
export function ragForScore(score) {
  if (score >= 4)   return { label: "Green", bg: "bg-emerald-50", text: "text-emerald-700", dot: "#10B981", border: "border-emerald-200" };
  if (score >= 3)   return { label: "Amber", bg: "bg-amber-50",   text: "text-amber-700",   dot: "#F59E0B", border: "border-amber-200" };
  return                  { label: "Red",   bg: "bg-red-50",     text: "text-red-700",     dot: "#EF4444", border: "border-red-200" };
}
